import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { BaseSiteService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { take, map } from "rxjs/operators";
import { ExcelDownloadService } from "src/app/shared/services/excel-download.service";
import { SanofiRulesService } from "../sanofi-rules.service";

interface SanofiRuleResponse{
  code:string;
  name:string;
  values:string;
}

@Component({
  selector: 'app-sanofi-rules',
  templateUrl: './sanofi-rules.component.html',
  styleUrls: ['./sanofi-rules.component.scss']
})
export class SanofiRulesComponent implements OnInit, OnDestroy{

  sanofiRulesArr: SanofiRuleResponse[] = [];
  sanofiRulesSubscription: any;
  uploadedFile: File;
  excelFileInvalidStatus: boolean = false;
  excelSheetfirstColumnName ='Values';
  empId:string='';
  // selectedFileName:string =''
  selectedFileNames:{[key:number]:string} ={}
  uploadClicked:{[key:number]:boolean} ={};
  userData: any = [];
  userSub:any;
  baseSiteId: string;

  constructor(
    private readonly sanofiRulesService: SanofiRulesService,
    private readonly cd: ChangeDetectorRef,
    public excelService: ExcelDownloadService,
    private readonly user: UserAccountFacade,
    private baseSiteService: BaseSiteService) { }

  ngOnInit(): void {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    //empId hardcoded temporarily, need to fetch from localstorage
    this.userSub = this.user.get().subscribe((res) => {
      if (res) {
          this.userData = res;
          // this.empId=this.userData?.uid;
      }
    });
    this.empId='asagent'; //To be removed after testing
    //Loading the table data with Sanofi rules
    this.getTableData(this.empId);
    this.userSub?.unsubscribe();
    
  }

  private getTableData(empId) {
    this.sanofiRulesService.fetchSanofiRulesDetails(empId);
    this.sanofiRulesSubscription = this.sanofiRulesService.sanofiRuleDetails$
      .subscribe((res) => {
        if (res !== null) {
          this.sanofiRulesArr = res.sanofiRules;
          this.cd.detectChanges();
        }
      });
  }

  downloadExcel(sanofiRuleId:string) {
    let fileName = 'VSH_Sanofi_Rules_';
    if(this.baseSiteId == 'vax'){
      fileName = 'VAX_Sanofi_Rules_';
    }
    this.sanofiRulesService.downloadSanofiRuleExcel(sanofiRuleId)
      .pipe(
          map(res =>{
            return res['values']
          })
        )
        .subscribe((res) => {
          if(res !== null){
          let newArr = res.map(val => ({'Values': val }));
            if(newArr?.length > 0)
            this.excelService.exportAsExcelFile(newArr, fileName + sanofiRuleId, true);
          } 
        });
}

onFileSelect(event, index:number) {
  // this.errorMsg = '';
        if (event.target.files.length > 0) {
        this.uploadedFile = (event.target as HTMLInputElement).files[0];
        this.selectedFileNames[index] = this.uploadedFile.name

        const fileParts = this.selectedFileNames[index].split('.');
        const extension = fileParts[fileParts.length - 1].trim().toLowerCase();

        if (extension === 'xlsx' || extension === 'xls') {
            this.excelService.validateExcelFile(this.uploadedFile, this.excelSheetfirstColumnName).subscribe(res => {
                if (res) {
                    this.excelFileInvalidStatus = false;
                    this.cd.detectChanges();
                } else {
                  //this.globalMessage.add('Customer number is blank or does not exist. Please check the excel', GlobalMessageType.MSG_TYPE_ERROR);
                    this.excelFileInvalidStatus = true;
                    this.cd.detectChanges();
                    //this.refreshValue();
                }
            });
        } else {
          //this.errorMsg = "The uploaded file should be xls format."
          this.excelFileInvalidStatus = true;
          this.refreshValue(index);
        }
    } 
}

  uploadFileDetails(sanofiRuleId:string, index:number) {
    this.uploadClicked[index]=true;
    let formData: FormData = new FormData();
    formData.append('selectedFile', this.uploadedFile, this.selectedFileNames[index]);
    this.sanofiRulesService.uploadSanofiRuleFileData(formData,sanofiRuleId).subscribe((res) => {
       if (res.status == 'success') {
           this.sanofiRulesSubscription?.unsubscribe();
           this.uploadClicked[index]=false;
           this.refreshValue(index);
           this.ngOnInit();
       } else {
          this.uploadClicked[index]=false;
           this.refreshValue(index);
        }
     })
 }


  refreshValue(index:number):void {
    this.selectedFileNames[index] ='';
  }

  getSelectedFileName(index:number):string{
    return this.selectedFileNames[index] || '' ;
  }

  getUploadClicked(index:number):boolean{
    return this.uploadClicked[index] || false ;
  }

  ngOnDestroy(): void {
    this.sanofiRulesSubscription?.unsubscribe();
    this.userSub?.unsubscribe();
  }
}
